<template>
  <div class="page-wrapper">
    <div class="content container-fluid">

      <div class="hero card mb-4 border-0 shadow-sm">
        <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="hero-icon mr-3">
              <i class="fa fa-map-marker"></i>
            </div>
            <div>
              <h3 class="page-title mb-1">Địa Điểm Chấm Công</h3>
              <div class="text-muted small">Cấu hình vị trí GPS và bán kính cho phép</div>
            </div>
          </div>
          <div>
            <button class="btn btn-primary mr-2" @click="openAdd">
              <i class="fa fa-plus mr-1"></i> Thêm địa điểm
            </button>
            <button class="btn btn-outline-secondary" @click="fetchData">
              <i class="fa fa-refresh mr-1"></i> Tải lại
            </button>
          </div>
        </div>
      </div>

      <div class="card shadow-sm">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Tên & Địa chỉ</th>
                <th>Tọa độ</th>
                <th class="text-center">Bán kính</th>
                <th class="text-center">Trạng thái</th>
                <th class="text-right">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, idx) in rows" :key="r.id">
                <td>{{ idx + 1 }}</td>
                <td>
                  <b>{{ r.tenDiaDiem }}</b><br>
                  <small>{{ r.diaChi }}</small>
                </td>
                <td>
                  Lat: {{ r.latitude }}<br>
                  Lng: {{ r.longitude }}
                </td>
                <td class="text-center">{{ r.banKinhAllow }} m</td>
                <td class="text-center">
                  <span :class="r.trangThai===1?'badge badge-success':'badge badge-secondary'">
                    {{ r.trangThai===1 ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td class="text-right">
                  <button class="btn btn-sm btn-warning mr-1" @click="openEdit(r)">
                    <i class="fa fa-pencil"></i>
                  </button>
                  <button class="btn btn-sm btn-danger" @click="confirmDelete(r)">
                    <i class="fa fa-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- MODAL -->
      <div class="modal custom-modal fade show" v-if="modals.edit" style="display:block; background: rgba(0,0,0,.5)">
        <div class="modal-dialog modal-dialog-centered" style="max-width:600px">
          <div class="modal-content">
            <div class="modal-header bg-light">
              <h5 class="modal-title">
                {{ form.id ? 'Cập nhật địa điểm' : 'Thêm địa điểm' }}
              </h5>
              <button type="button" class="close" @click="closeEdit">&times;</button>
            </div>

            <div class="modal-body">
              <form @submit.prevent="submitForm">

                <div class="form-group">
                  <label>Tên địa điểm</label>
                  <input class="form-control" v-model="form.tenDiaDiem" required>
                </div>

                <div class="form-group">
                  <label>Địa chỉ</label>
                  <textarea class="form-control" v-model="form.diaChi"></textarea>
                </div>

                <!-- LINK GOOGLE MAPS -->
                <div class="form-group">
                  <label>Link Google Maps</label>
                  <div class="input-group">
                    <input class="form-control" v-model="form.mapsUrl" placeholder="Dán link Google Maps">
                    <div class="input-group-append">
                      <button class="btn btn-outline-primary" type="button"
                        @click="extractLatLngFromUrl">
                        Lấy tọa độ
                      </button>
                    </div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label>Latitude</label>
                    <input class="form-control" type="number" step="0.0000001" v-model.number="form.latitude" required>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Longitude</label>
                    <input class="form-control" type="number" step="0.0000001" v-model.number="form.longitude" required>
                  </div>
                </div>

                <div class="form-group">
                  <label>Bán kính (m)</label>
                  <input class="form-control" type="number" v-model.number="form.banKinhAllow">
                </div>

                <div class="form-group">
                  <label>
                    <input type="checkbox" v-model="form.trangThaiBool">
                    Đang hoạt động
                  </label>
                </div>

                <div v-if="errorMsg" class="alert alert-danger">{{ errorMsg }}</div>

                <div class="text-right">
                  <button class="btn btn-secondary mr-2" @click="closeEdit">Hủy</button>
                  <button class="btn btn-primary" type="submit">Lưu</button>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from '../api';
import Swal from 'sweetalert2';

export default {
  data() {
    return {
      API: '/api/admin/dia-diem-cham-cong',
      rows: [],
      modals: { edit: false },
      errorMsg: '',
      form: {
        id: null,
        tenDiaDiem: '',
        diaChi: '',
        latitude: null,
        longitude: null,
        banKinhAllow: 3000,
        trangThaiBool: true,
        mapsUrl: ''
      }
    };
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      const res = await axios.get(this.API);
      this.rows = res.data?.data || res.data || [];
    },

    openAdd() {
      this.errorMsg = '';
      this.form = {
        id: null, tenDiaDiem: '', diaChi: '',
        latitude: null, longitude: null,
        banKinhAllow: 3000, trangThaiBool: true, mapsUrl: ''
      };
      this.modals.edit = true;
    },

    openEdit(r) {
      this.errorMsg = '';
      this.form = {
        id: r.id,
        tenDiaDiem: r.tenDiaDiem,
        diaChi: r.diaChi,
        latitude: r.latitude,
        longitude: r.longitude,
        banKinhAllow: r.banKinhAllow,
        trangThaiBool: r.trangThai === 1,
        mapsUrl: ''
      };
      this.modals.edit = true;
    },

    closeEdit() {
      this.modals.edit = false;
    },

    async submitForm() {
      const payload = {
        tenDiaDiem: this.form.tenDiaDiem,
        diaChi: this.form.diaChi,
        latitude: this.form.latitude,
        longitude: this.form.longitude,
        banKinhAllow: this.form.banKinhAllow,
        trangThai: this.form.trangThaiBool ? 1 : 0
      };

      if (this.form.id) {
        await axios.put(`${this.API}/${this.form.id}`, payload);
      } else {
        await axios.post(this.API, payload);
      }

      this.closeEdit();
      this.fetchData();
    },

    async confirmDelete(r) {
      const ok = confirm('Xóa địa điểm này?');
      if (!ok) return;
      await axios.delete(`${this.API}/${r.id}`);
      this.fetchData();
    },

    // ================= GOOGLE MAPS PARSER =================
    extractLatLngFromUrl() {
      if (!this.form.mapsUrl) {
        this.errorMsg = 'Vui lòng dán link Google Maps';
        return;
      }

      const rs = this.parseLatLngFromUrl(this.form.mapsUrl);
      if (!rs) {
        this.errorMsg = 'Không đọc được tọa độ từ link';
        return;
      }

      this.form.latitude = rs.lat;
      this.form.longitude = rs.lng;
      this.errorMsg = '';

      Swal.fire('Thành công', 'Đã lấy tọa độ từ Google Maps', 'success');
    },

    parseLatLngFromUrl(urlStr) {
      let lat = null, lng = null;

      try {
        const u = new URL(urlStr);

        const q = u.searchParams.get('q') || u.searchParams.get('query');
        if (q) {
          const m = q.match(/(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)/);
          if (m) {
            lat = parseFloat(m[1]);
            lng = parseFloat(m[3]);
          }
        }

        if (lat == null) {
          const path = u.pathname;
          const i = path.indexOf('/@');
          if (i !== -1) {
            const sub = path.substring(i + 2);
            const m = sub.match(/(-?\d+(\.\d+)?),(-?\d+(\.\d+)?)/);
            if (m) {
              lat = parseFloat(m[1]);
              lng = parseFloat(m[3]);
            }
          }
        }

        if (lat == null) {
          const m = urlStr.match(/!3d(-?\d+(\.\d+)?)!4d(-?\d+(\.\d+)?)/);
          if (m) {
            lat = parseFloat(m[1]);
            lng = parseFloat(m[3]);
          }
        }

        if (lat == null) {
          const m = urlStr.match(/(-?\d+(\.\d+)?),\s*(-?\d+(\.\d+)?)/);
          if (m) {
            lat = parseFloat(m[1]);
            lng = parseFloat(m[3]);
          }
        }

      } catch (e) {
        return null;
      }

      if (lat == null || lng == null) return null;
      return { lat, lng };
    }
  }
};
</script>

<style scoped>
.hero-icon {
  width: 48px;
  height: 48px;
  background: #e0f2fe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
